import React, { useEffect, useState, useContext } from "react";
import { Link } from 'react-router-dom';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
import { Timeline } from 'react-twitter-widgets'
import OneSignal from 'react-onesignal';

// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarEventos from "../element/CarEventos"
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// import CarNotificaciones from "../element/CarNotificaciones";
import Menu from "../componentes/Menu";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import GetFetchNotificaciones from "../helper/GetFetchNotificaciones";
import loadMenu from "../js/main";
import dataSuper from '../hooks/Conf';
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import Footer from '../componentes/Footer';

const Eventos = () => {

    const history = useHistory();
    const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    const [eventos, setEventos] = useState({});
    const [notificaciones, setNotificaciones] = useState({});
    const [alerta, setAlerta] = useState(false);
    const [cargando, setCargando] = useState(true);

    if (datos) {
        let cred = JSON.parse(datos);
        dataUser.token = cred.token;
        dataUser.nombre = cred.nombre;
        dataUser.carnet = cred.carnet;
        dataUser.correo = cred.correo;

        if (dataSuper.indexOf(cred.carnet.trim()) === -1) {
            if (dataDireccionEstudiantil.indexOf(cred.carnet.trim()) === -1) {
                history.push("/");
            }
        }
    } else {
        history.push("/");
    }

    let alertaVisualNoti = (dataNoti)=>{
        let alertaNoti = localStorage.getItem('alertaNotiLocal');
        if (alertaNoti) {
            let tempNoti = JSON.parse(alertaNoti);
            //Recorriendo el resultado de notificaciones de la nube
            dataNoti.map((elemento)=>{
                //Ver si existe ID de notificaciones guardadas
                if (tempNoti.indexOf(elemento._id.trim()) === -1) {
                    setAlerta(true);
                    // sonarAudio();
                }
               
                return null;
            })
            
        }else{
            setAlerta(true);
            // sonarAudio();
        }
        return null;
    }

    // let sonarAudio = ()=>{
    //     var audio = document.getElementById("audio");
    //     audio.play();

    //     setTimeout(() => {
    //         audio.play();
    //     }, 5000);

    //     setTimeout(() => {
    //         audio.play();
    //     }, 10000);
    // }

    useEffect(() => {
        GetFetch.getEventos(dataUser.token)
            .then((eventosData) => {
                if (eventosData.length > 0) {
                    setEventos(eventosData.reverse());
                }
                setCargando(false);
            }).catch(() => setCargando(false));

        //Llamando a las notificaciones
        if (dataSuper.indexOf(dataUser.carnet.trim()) === -1) {
            if (dataUser.perfil === 'Alumnos') {
            if (dataUser.carrera === 'Ingeniería de Negocios') {
                dataUser.perfil = 'IDN' + dataUser.carnet.substr(0,4);
            }
            if (dataUser.carrera === 'Ciencias Jurídicas') {
                dataUser.perfil = 'LCJ' + dataUser.carnet.substr(0,4);
            }
            if (dataUser.carrera === 'Economía y Negocios') {
                dataUser.perfil = 'LEN' + dataUser.carnet.substr(0,4);
            }
            }
    
            GetFetchNotificaciones.getNotificaciones(dataUser.token, dataUser.carrera, dataUser.perfil).then((dataNoti) => {
             setNotificaciones(dataNoti);
             alertaVisualNoti(dataNoti); 
            });
            
        }else{
            GetFetchNotificaciones.getNotificacionesAll(dataUser.token).then((dataNoti) => {
                setNotificaciones(dataNoti);    
                alertaVisualNoti(dataNoti);        
            });
        }

      loadMenu();
    }, [dataUser]);

    useEffect(() => {
        OneSignal.init({
          appId: "7604e2b7-4287-4a83-86e7-05430366115a",
          path: 'https://api.esen.edu.sv/notificationpush/OneSignalSDKWorker.js'
        });
      }, []);

    return (

        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

                    <HeaderMenu
                        carnet={dataUser.carnet}
                        nombre={dataUser.nombre}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">Eventos y noticias</h2>

                <div className="d-flex justify-content-end align-items-center mb-3">
                    {
                        alerta
                            ?
                            <Link className="btn btn-outline-primary btn-sm mr-2" to="/notificaciones">
                                <i className="fa fa-bullhorn mr-1" aria-hidden="true"></i>
                                Notificaciones nuevas
                            </Link>
                            :
                            null
                    }
                    <Link to="/adminevento" className="btn btn-primary">
                        <i className="fa fa-calendar mr-2" aria-hidden="true"></i>
                        Nuevo evento
                    </Link>
                </div>

                {
                    cargando
                        ?
                        <SkeletonCard rows={4} />
                        :
                        eventos.length > 0
                            ?
                            eventos.map((element) => {
                                return (
                                    <CarEventos
                                        key={element.id_noticia}
                                        elemento={element}
                                        tardie="1"
                                        autor={dataUser.correo}
                                    />
                                )
                            })
                            :
                            <EmptyState icon="fa-calendar-o" title="Aún no hay eventos">
                                Cuando publiques un evento o noticia aparecerá en esta lista.
                            </EmptyState>
                }
                <Timeline
                dataSource={{
                    sourceType: 'profile',
                    screenName: 'esenelsalvador'
                }}
                options={{
                    height: '1000',
                    chrome: "noheader, nofooter"
                }}
                />
            </div>
        </div>
    );
}

export default Eventos;